import { render, staticRenderFns } from "./ShareProject.vue?vue&type=template&id=3dcd7545&scoped=true&"
import script from "./ShareProject.vue?vue&type=script&lang=js&"
export * from "./ShareProject.vue?vue&type=script&lang=js&"
import style0 from "./ShareProject.vue?vue&type=style&index=0&id=3dcd7545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcd7545",
  null
  
)

export default component.exports